import React from 'react'
import OnVisible from 'react-on-visible'
import { Section } from 'newComponents'
import './styles.scss'

const HtmlTable = (props) => {
  const { data } = props
  const { primary, items } = data
  const {
    table_heading_1: th1,
    table_heading_2: th2,
    table_heading_3: th3,
    table_heading_4: th4,
    table_heading_5: th5,
    table_heading_6: th6,
    table_title: title
  } = primary

  const titleHtml = title?.html

  const headingsRaw = [th1, th2, th3, th4, th5, th6]
  // filter by headings with value
  const headings = headingsRaw.filter((heading) => heading?.text)

  return (
    <Section className="custom-table">
      {titleHtml && <div dangerouslySetInnerHTML={{ __html: title.html }} className="custom-table-title" />}
      <table className="custom-table-container">
        <thead>
          <tr className="custom-table-row">
            {headings.map((heading) => {
              const { html: headingHtml, text: key } = heading
              return (
                <th className="custom-table-heading custom-table-row-cell" key={key}>
                  {headingHtml && (
                    <div dangerouslySetInnerHTML={{ __html: headingHtml }} className="custom-table-heading-text" />
                  )}
                </th>
              )
            })}
          </tr>
        </thead>

        <tbody>
          {items.map((row) => {
            const {
              row_data_1: rd1,
              row_data_2: rd2,
              row_data_3: rd3,
              row_data_4: rd4,
              row_data_5: rd5,
              row_data_6: rd6
            } = row
            const rowRaw = [rd1, rd2, rd3, rd4, rd5, rd6]
            const rowData = rowRaw.filter((rData) => rData?.text)

            if (!rowData[0]) return null

            return (
              <tr className="custom-table-row" key={rowData[0].text}>
                {rowData.map((cell) => {
                  const { html: cellHtml, text: key } = cell
                  return (
                    <td className="custom-table-row-cell" key={key}>
                      {cellHtml && (
                        <div dangerouslySetInnerHTML={{ __html: cellHtml }} className="custom-table-row-cell-text" />
                      )}
                    </td>
                  )
                })}
              </tr>
            )
          })}
        </tbody>
      </table>
    </Section>
  )
}

export default HtmlTable
